import React from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import {
  Row, Col, Button, Icon, Modal, Spin
} from 'antd';
import util from '../../util/index';
import Editor from 'for-editor'
import base from '../../tool/base';
import validate from '../util/appApply/validate';
import CaseApply from '../util/caseApply/index';
import ApplyApp from '../util/appApply/index';

const { isWeaver, getMiddleUrl, getAccessToken } = util;
const {
  checkLicense,
} = validate;
const store = ['themeListStore', 'listStore', 'modeListStore', 'homeStore', 'caseListStore'];
@inject(...store)
@observer
class App extends React.Component {
  static defaultProps = {
    prefixCls: 'main-portal'
  }
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      markdownValue: ''
    };
  }
  onClick = (e, id) => {
    const { themeListStore: { routing }, homeStore: { setType } } = this.props;
    routing.push(`/app/appDetail/${id}`);
    setType('theme', '门户主题');
    e.stopPropagation && e.stopPropagation();
    e.preventDefault && e.preventDefault();
    e.nativeEvent && e.nativeEvent.preventDefault();
  }
  collect = (e, data) => {
    const { listStore: { params: { searchValue } }, themeListStore: { getThemeE8List, callCollect }  } = this.props;
    callCollect({ collect: data.tms_iscoll === '1' ? '0' : '1', s_ids: data.sw_id }).then(data => {
      getThemeE8List({ searchValue, pageNum: 1, pageSizi: 8  });
    });
    e.stopPropagation && e.stopPropagation();
    e.preventDefault && e.preventDefault();
    e.nativeEvent && e.nativeEvent.preventDefault();
  }
  previewCase = (e, readme) => {
    this.setState({
      visible: true,
      markdownValue: readme
    });
  }
  onFormChange = (values, allValues) => {
    const { modeListStore: { applyLicense, setMobxState, appDetail } } = this.props;
    const data = toJS(appDetail);
    setMobxState({ isApply: false });
    if (Object.keys(values).indexOf('license') >= 0) {
      checkLicense(values.license) && applyLicense({
        sw_id: data.sw_id,
        ec_id: allValues.c_id,
        c_id: allValues.c_id,
        ecname: allValues.c_name,
        license: values.license,
      });
    }
  }
  onCaseFormChange = (changed, allValues) => {
    const { caseListStore: { setApply } } = this.props;
    setApply({...changed});
  }
  onCancel = () => {
    this.setState({visible: false, markdownValue: ''});
  }
  download = (e, id, folderId) => {
    const url = `${window.server}/v5/ecode/download?id=${id}&access_token=${getAccessToken()}`;
    const { getDatas } = this.props;
    base.callApi('/v5/ecode/downloadCount', 'POST', {appId: folderId}, 'json', 'text').then((data) => {
      if (data.status) {
        window.open(url);
        getDatas();
      } else {
        console.error("后端接口异常，请联系管理员！");
      }
    });
  }
  apply = (id, name, kbVersion) => {
    const { caseListStore: { setApply, setState } } = this.props;
    setApply({appId: id, title: name, kb: kbVersion})
    setState({applyVisible: true});
  }
  applyPermissions = (e, obj) => {
    const { caseListStore: { setApply, setState } } = this.props;

    setApply({appId: obj.id, title: obj.name, kb: obj.kb});
    setState({applyVisible: true, isPermissions: true});

    e.stopPropagation && e.stopPropagation();
    e.preventDefault && e.preventDefault();
    e.nativeEvent && e.nativeEvent.preventDefault();
  }
  doThumbsub = (folderId) => {
    const { getDatas, themeListStore: { thumbsupAdd, getThemeList }, listStore: { params: { searchValue } } } = this.props;
    thumbsupAdd({ appId: folderId }).then(() => {
      typeof getDatas === 'function' ? getDatas() : getThemeList({ title: searchValue, pageNum: 1, pageSizi: 8 }, false);
    });
  }
  render() {
    const { visible, markdownValue } = this.state;
    let { prefixCls, extraCls, apply, caseList, themeList: _themeList, onStars, getDatas,
      themeListStore: { themeList, themeListE8, getThemeList }, 
      homeStore: { view, addCollect, addCollectLoading }, 
      caseListStore: { setState, applyVisible },
      modeListStore: { appDetail, setMobxState, visibleOfApply }, 
      listStore: { params: { searchValue } },
    } = this.props;
    if(caseList || _themeList) {
      //全部应用页面数据
      themeList = caseList ? caseList : _themeList;
    } else {
      //主页数据
      let themeListAll = [...toJS(themeList), ...toJS(themeListE8)];
      themeListAll = themeListAll.length > 8 ? themeListAll.splice(0, 8) : themeListAll;
      themeList = themeListAll;
    }
    return (
      <Row className={`home-page-theme-list-body ${prefixCls} ${extraCls}`}>
        {
          themeList.map(list => {
            const isE9 = !!list.folderId;
            return (
              <Col span={6} key={list.id || list.sw_id} className='home-page-theme-list-item' onClick={(e) => { list.id || this.onClick(e, list.sw_id) }}>
                <div className='home-page-theme-list-item-card' >
                    {
                    !caseList && 
                      <span className="version-tag" style={isE9 ? { background: '#007AFF' } : {}}>
                        {isE9? 'E9' : 'E8' }
                      </span>
                    }
                    <img src={list.imageList ? list.imageList[0].imageLink : `https://www.e-cloudstore.com/${list.s_docfile}`} alt='' />
                    <div className='theme-card-mask' />
                    <div className='theme-card-title'>
                      <h1 title={list.title || list.s_name}>{list.title || list.s_name}</h1>
                        {
                          caseList && (
                            <Button
                              type='primary'
                              onClick={(e) => {
                                // window.open('http://203.110.166.60:8088/login/login4wf.jsp?userid=1&gopage=' +
                                //   `/cloudstore/system/index.jsp#/${list.s_number}/set`);
                                if(list.sw_id) {
                                  view(list);
                                }else {
                                  this.previewCase(e, list.readme);
                                }
                                e.stopPropagation && e.stopPropagation();
                                e.preventDefault && e.preventDefault();
                                e.nativeEvent && e.nativeEvent.preventDefault();
                              }}
                            >
                              详情
                            </Button>
                          )
                        }
                        {isE9 && (
                          <Button
                            style={{ padding: "0 6px" }}
                            disabled={!isWeaver()}
                            onClick={(e) => {
                              this.applyPermissions(e, {id: list.folderId || list.sw_id, name: list.title, kb: list.kbVersion})
                            }}
                          >
                            申请开发授权
                          </Button> 
                        )}
                        {
                          list.attr && list.attr.caseType === 'case' ?
                          <Button
                            onClick={(e) => {
                              this.download(e, list.id, list.folderId);
                              e.stopPropagation && e.stopPropagation();
                              e.preventDefault && e.preventDefault();
                              e.nativeEvent && e.nativeEvent.preventDefault();
                            }}
                          >
                            下载
                          </Button> :                        
                          <Button
                          disabled={!isWeaver()}
                          onClick={(e) => {
                            list.attr && list.attr.caseType === 'app' ?
                              this.apply(list.folderId, list.title, list.kbVersion) : 
                              apply(list, 'theme');
                            e.stopPropagation && e.stopPropagation();
                            e.preventDefault && e.preventDefault();
                            e.nativeEvent && e.nativeEvent.preventDefault();
                          }}
                        >
                          申请
                        </Button>}
                  </div>
                  {
                    isWeaver() && !isE9 && (!list.attr || list.attr.caseType !== 'case') && (
                      <div className={`theme-card-title-collect`} onClick={(e) => this.collect(e, list)}>
                        {list.tms_iscoll === '1' ? (<Icon type="star" />) : (<Icon type="star" theme="filled" style={{ color: '#1e94ff' }} />) }
                        <span>{list.tms_iscoll === '1' ? '收藏' : '取消收藏'}</span>
                      </div>
                    )
                  }
                </div>
                <div className='home-page-theme-e9Info'>
                  {
                    isE9 && [
                      <div  className="home-page-theme-e9Info-num" key="home-page-theme-e9Info-num">
                        <span className="home-page-theme-e9Info-num-left">
                          <Icon type="eye" className="home-page-theme-e9Info-num-icon" />
                          {list.visits || 0}
                        </span>
                        <span className="home-page-theme-e9Info-num-left">
                          <Icon type="download" className="home-page-theme-e9Info-num-icon" />
                          {list.downloadCounts || 0}
                        </span>
                        <span className="pointer" onClick={() => onStars ? onStars(list.folderId) : this.doThumbsub(list.folderId) }>
                          <Icon type="heart" className={`home-page-theme-e9Info-num-icon ${list.thumbsupStatus === 'y' ? "heart-active" : ""}`} theme={list.thumbsupStatus === 'y' ? "filled" : "" } />
                          {list.thumbsup || 0}
                        </span>
                        <div className="home-page-theme-e9Info-desc">
                          <span 
                            className="home-page-theme-e9Info-desc-single" 
                            onClick={() => {
                              if(!addCollectLoading) { 
                                addCollect({appId: list.folderId}).then(data => 
                                  data.status && 
                                    typeof getDatas === 'function' ? getDatas() 
                                      : getThemeList({ title: searchValue, pageNum: 1 }, false)
                                );
                              }
                            }}
                          >
                            {list.starStatus === 'y' ? '取消收藏' : '收藏'}
                          </span>
                          {
                            list.attr && list.attr.detailsUrl && list.attr.detailsUrl !== '' && (
                              <span className="home-page-theme-e9Info-desc-single" onClick={() => window.open(list.attr.detailsUrl)}>
                                详情
                              </span>
                            )
                          }
                          {
                            list.attr && list.attr.previewUrl && list.attr.previewUrl !== '' && (
                              <span className="home-page-theme-e9Info-desc-single" onClick={() => window.open(`${list.attr.previewUrl}&ecodessoid=test`)}>
                                预览
                              </span>
                            )
                          }
                        </div>
                      </div>,
                      <div key="home-page-theme-e9Info-title" className="home-page-theme-e9Info-title text-elli" title={list.title}>
                        {list.title}
                      </div>
                    ]
                  }
                </div>
              </Col>
            );
          })
        }
        <Modal
            title="详情"
            visible={visible}
            bodyStyle={{
              padding: 0,
              height: 520,
            }}
            style={{
              top: 50,
            }}
            maskClosable={false}
            width={900}
            onCancel={this.onCancel}
            footer={
              <Button type="primary" className="home-page-preview-button" onClick={this.onCancel}>关闭预览</Button>
            }
        >
          {markdownValue ? 
            <Editor
              value={markdownValue}
              preview
              toolbar={{}}
              style={{
                height: '100%',
                borderRadius: 0,
                border: 'none'
              }}
            /> : 
            <Spin><div style={{ width: '100%', height: 500 }} /></Spin>
          }
        </Modal>
        <ApplyApp visible={visibleOfApply} onChange={(v) => setMobxState({ visibleOfApply: v })} data={toJS(appDetail)} onFormChange={this.onFormChange} />
        <CaseApply visible={applyVisible} onCancel={() => setState({applyVisible: false}) } onFormChange={this.onCaseFormChange} />
      </Row>
    )
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/main/Portal.js